import { render, staticRenderFns } from "./ScoreRecord.vue?vue&type=template&id=455ab532&scoped=true"
import script from "./ScoreRecord.vue?vue&type=script&lang=js"
export * from "./ScoreRecord.vue?vue&type=script&lang=js"
import style0 from "./ScoreRecord.vue?vue&type=style&index=0&id=455ab532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ab532",
  null
  
)

export default component.exports